import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import HeartWrapper from 'dibs-portfolio-heart';
import { ItemTile } from 'dibs-search-product-tile/exports/ItemTile';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { getEverLoggedIn } from 'dibs-cookie-jar';
import { SAVE_ITEM_FLOW } from 'dibs-buyer-layout/src/authModal/authentication/authFlowConstants';
import { trackEvent } from 'dibs-tracking';

import FolderWrapperWrapper from '../sharedComponents/FolderWrapperWrapper';
import { getFolderTrackingHooks, locations } from '../utils/folderTracking';
import { ServerVarsContextConsumer } from '../sharedComponents/ServerVarsContext';

// Styles
import styles from './styles/ShoppingWithTile.scss';

class ShoppingWithTileComponent extends React.Component {
    constructor(props) {
        super(props);

        this.authModalShow = this.authModalShow.bind(this);
    }

    authModalShow(favoriteItem) {
        const everLoggedIn = getEverLoggedIn(document.cookie);

        if (!this.props.hasUserId) {
            authModalLoader
                .show({
                    action: everLoggedIn
                        ? authModalLoader.constants.LOGIN
                        : authModalLoader.constants.REGISTER,
                    flow: SAVE_ITEM_FLOW,
                    ga: {
                        label: 'save item - shopping with page',
                    },
                })
                .then(favoriteItem);
        }
    }

    trackFavoriting(action, itemId) {
        let trackObj = {
            action,
            label: 'shopping with',
            category: 'item favoriting',
        };

        if (itemId) {
            trackObj = { ...trackObj, additional: { itemId } };
        }

        trackEvent(trackObj);
    }

    render() {
        const {
            currency,
            hasUserId,
            viewer,
            index,
            item,
            onContentLoaded,
            selectedItemIds,
            shouldFillInFolder,
            loadPortfolioData,
            trackProductClick,
            userId,
            activeQuickView,
            openQuickView,
            closeQuickView,
            isClient,
        } = this.props;

        const getFavoritesComponent = isMobile => (
            <div className={styles.iconWrapper}>
                <div className={styles.heart}>
                    <HeartWrapper
                        authModalShow={this.authModalShow}
                        itemId={item.serviceId}
                        loadPortfolioData={loadPortfolioData}
                        onFavorited={() => this.trackFavoriting('item added', item.serviceId)}
                        onUnFavorited={() => this.trackFavoriting('item removed', item.serviceId)}
                        selectedItemIds={selectedItemIds}
                        userId={hasUserId ? userId : null}
                        userIds={hasUserId ? [userId] : []}
                        viewer={viewer ? viewer : null}
                    />
                </div>
                {!isMobile && (
                    <div className={styles.folder}>
                        <FolderWrapperWrapper
                            authModalTrackingLabel="save item - similar items"
                            primaryItemPk={item.serviceId}
                            selectedItemIds={selectedItemIds}
                            selectedItemImages={
                                item.firstPhotoWebPath ? [item.firstPhotoWebPath] : []
                            }
                            selectedItemTitles={item.title ? [item.title] : []}
                            shouldFillInFolder={shouldFillInFolder}
                            singlePortfolioItem
                            trackingHooks={getFolderTrackingHooks(locations.VISUALLY_SIMILAR)}
                            userId={hasUserId ? userId : null}
                            userIds={hasUserId ? [userId] : []}
                            viewer={viewer ? viewer : null}
                        />
                    </div>
                )}
            </div>
        );
        return (
            <ServerVarsContextConsumer>
                {({ isMobile }) => (
                    <ItemTile
                        currency={currency}
                        index={index}
                        isMobile={isMobile}
                        item={item}
                        itemSearch={null}
                        itemsPerRow={3}
                        onClick={() => trackProductClick(item)}
                        onContentLoaded={onContentLoaded}
                        showSellerName={false}
                        showQuickView
                        activeQuickView={activeQuickView}
                        openQuickView={openQuickView}
                        closeQuickView={closeQuickView}
                        useLoFiLazyLoader
                        viewer={null}
                        showMSKUSwatch={false}
                        showMeasurements={false}
                        showPrice={isClient}
                        favoritesComponent={getFavoritesComponent(isMobile)}
                    />
                )}
            </ServerVarsContextConsumer>
        );
    }
}

ShoppingWithTileComponent.propTypes = {
    currency: PropTypes.string,
    deviceType: PropTypes.string,
    hasUserId: PropTypes.bool,
    viewer: PropTypes.object,
    index: PropTypes.number,
    item: PropTypes.object.isRequired,
    activeQuickView: PropTypes.number,
    openQuickView: PropTypes.func.isRequired,
    closeQuickView: PropTypes.func.isRequired,
    onContentLoaded: PropTypes.func,
    selectedItemIds: PropTypes.array,
    shouldFillInFolder: PropTypes.bool,
    loadPortfolioData: PropTypes.bool,
    trackProductClick: PropTypes.func,
    userId: PropTypes.string,
    isClient: PropTypes.bool,
};

ShoppingWithTileComponent.defaultProps = {
    onContentLoaded: () => {},
    trackProductClick: () => {},
};

export const ShoppingWithTile = createFragmentContainer(ShoppingWithTileComponent, {
    item: graphql`
        fragment ShoppingWithTile_item on Item {
            categoryPath
            ecommerceTrackingParams
            firstPhotoWebPath(size: small)
            serviceId
            title
            ...ItemTile_item @arguments(isTrade: $isTrade)
        }
    `,
});
